<template>
  <div>
    <div class="shopping-root-view">
      <div @click="toggleShowShoppingCart" class="shopping-cart-container">
        <div class="shopping-cart-icon">
          <img
            class="icon"
            src="../../../static/img/shopping_cart/icon_gwc.png"
          />
          <div class="meals-number">{{ totalCounts }}</div>
        </div>
        <div class="shopping-cart-text">
          <div class="text">购物车</div>
          <img class="arrow-icon" :src="arrowUrl" />
        </div>
      </div>
      <div
        :class="{
          animateIn: $store.state.is_show_shopping_cart,
          animateOut: !$store.state.is_show_shopping_cart,
        }"
        class="shopping-record"
      >
        <!-- 新增咖啡订单 start-->
        <div
          v-if="shopping_coffee_data.length"
          name="list"
          class="record-view-coffee"
        >
          <div class="shop-view">
            <img
              class="shop-icon"
              src="../../../static/img/shopping_cart/icon_wdpj_dp.png"
            />
            <span class="shop-title">咖啡吧</span>
          </div>
          <CofeeShopItem
            v-for="(item, index) in shopping_coffee_data"
            :key="index"
            :record="item"
          />
          <label v-if="true" class="remarks-view">
            <img
              src="../../../static/img/shopping_cart/icon_bz.png"
              class="remarks-icon"
            />
            <span class="remarks-title">备注</span>
            <input v-model="coffeeRemark" class="remarks-text" />
          </label>
        </div>
        <!-- 新增咖啡订单end -->
        <transition-group
          v-if="$store.state.shopping_cart_data.length"
          name="list"
          class="record-view"
        >
          <transition-group
            name="list"
            v-for="(items, index) in $store.state.shopping_cart_data"
            :key="items[0].busi_id"
          >
            <RecordItem
              v-for="(item, i) in items"
              :key="item.menu_spec_id + item.menu_id"
              :record="item"
              :arrIndex="index"
              :itemIndex="i"
              :totalLength="items.length - 1"
            />
          </transition-group>
        </transition-group>

        <div
          v-if="
            !$store.state.shopping_cart_data.length &&
            !shopping_coffee_data.length
          "
          class="record-view"
        >
          <div class="no-goods">暂无商品信息</div>
        </div>
        <div v-if="totalCounts > 0" class="submit-view">
          <div class="bl" />
          <div class="totao-price">
            <span class="price-text">订单总价：</span>
            <span class="price">¥{{ totalPrice }}</span>
          </div>
          <div class="submit-wrapper">
            <span @click="clearShoppingCart" class="clear">清空购物车</span>
            <span @click="toggleShowConfirmOrder" class="submit">
              <img
                v-if="submiting"
                class="submiting-img"
                src="../../../static/img/login/loging.gif"
              />
              <span v-else>提交订单</span>
            </span>
          </div>
        </div>
        <div v-else @click="checkOrders" class="goto-orders">查看订单</div>
      </div>
    </div>
    <ConfirmOrder
      v-if="showConfirmOrderView"
      @toggleShowConfirmOrder="toggleShowConfirmOrder"
      @submit="submit"
    />
  </div>
</template>

<script>
import RecordItem from "@/components/shopping_cart/record_item";
import CofeeShopItem from "@/components/coffee/components/CofeeShopItem.vue";
import LEFT_ARROW from "../../../static/img/shopping_cart/icon_gwc_zk.png";
import RIGHT_ARROW from "../../../static/img/shopping_cart/icon_gwc_sq.png";
import ConfirmOrder from "./confirm_order";
import { mapGetters } from "vuex";

export default {
  name: "ShoppingCart",
  components: {
    RecordItem,
    ConfirmOrder,
    CofeeShopItem,
  },
  data() {
    return {
      submiting: false,
      totalPrice: 0,
      showConfirmOrderView: false,
      coffeeRemark: "", //咖啡备注
    };
  },
  computed: {
    ...mapGetters({
      shopping_coffee_data: "shopping_coffee_data",
    }),
    /**
     * 点击更换arrow图标
     */
    arrowUrl() {
      return this.$store.state.is_show_shopping_cart ? RIGHT_ARROW : LEFT_ARROW;
    },
    /**
     * 购物车里的商品总数量
     */
    totalCounts() {
      if (
        !this.$store.state.shopping_cart_data.length &&
        !this.shopping_coffee_data.length
      ) {
        this.totalPrice = 0;
        return 0;
      } else {
        let count = 0,
          price = 0,
          tempPrice = 0;
        if (this.$store.state.shopping_cart_data.length) {
          this.$store.state.shopping_cart_data.map((items, index) => {
            items.map((item, i) => {
              // 查看购物车里该商品是否有优惠价，如果有优惠价，总价里计入该商品的优惠价
              tempPrice = item.dis_price ? item.dis_price : item.actual_price;
              count += item.meal_count;
              price += tempPrice * item.meal_count;
            });
          });
        }
        //咖啡的总金额进行累加
        if (this.shopping_coffee_data.length) {
          this.shopping_coffee_data.forEach((x) => {
            price += x.prize * x.shopValue;
            count += x.shopValue;
          });
        }

        // 购物车里菜品总价, 设置小数点精度为小数点后两位
        this.totalPrice = price.toFixed(2);
        return count;
      }
    },
  },
  methods: {
    /**
     * 跳转到订单页面
     */
    checkOrders() {
      this.$router.push("/p/user/order");
    },
    /**
     * 打开或者关闭购物车
     */
    toggleShowShoppingCart() {
      this.$store.commit("toggle_show_shopping_cart");
    },
    /**
     * 清空购物车
     */
    clearShoppingCart() {
      if (
        this.$store.state.shopping_cart_data.length === 0 &&
        !this.shopping_coffee_data.length
      ) {
        this.$store.commit("show_alert", "购物车现在已经是空的呦");
        return;
      }
      this.$store.commit("clear_shopping_cart_data");
      this.$store.commit("updataCoffeeShop", []);
      this.coffeeRemark=''
    },

    // 咖啡服务请求
    coffeeSubmit() {
      const payload = {
        remark: this.coffeeRemark,
        details: this.shopping_coffee_data.map((x) => {
          return {
            drinkID: x.id,
            amount: x.shopValue,
            info: x.preferences.join("/"),
          };
        }),
      };
      this.axios.post("/drinks/order/submit", payload).then((res) => {
        this.submiting = false;
        if (res.code === 0) {
          // Toast.success("咖啡下单成功");
          this.$store.commit("show_alert", "咖啡下单成功");
          this.coffeeRemark=''
          // 成功后移除购物车
          this.$store.commit("updataCoffeeShop", []);
        } else {
          if (res.code === 1009) {
            this.$store.commit("show_alert", "部分咖啡已售罄");
          } else if (res.code === 1013) {
             this.$store.commit("show_alert", "商家未在营业");
          }else if (res.code === 217) {
             this.$store.commit("show_alert", "该饮品已不存在");
          } else {
            this.$store.commit("show_alert", "咖啡下单失败");
          }  
        }
      });
    },
    /**
     * 提交订单
     */
    submit() {
      this.toggleShowConfirmOrder();
      // 咖啡订单提交
      if (this.shopping_coffee_data.length) {
        this.coffeeSubmit();
      }

      // 普通订单提交
      if (this.$store.state.shopping_cart_data.length) {
        this.submiting = true;
        let totalMealParams = {
          floor: this.$store.state.user_info.position,
          order_menu: [],
          select_id: this.$store.state.meals.select_id,
          user_id: this.$store.state.user_info.id,
        };
        this.$store.state.shopping_cart_data.map((items, index) => {
          // 生成订单数据
          let shopParams = {
            busi_id: items[0].busi_id,
            dis_id: items[0].dis_id,
            notice: this.$store.state.remarks[index],
            menu: [],
          };
          items.map((item, i) => {
            let menu_item = {
              actual_price: item.actual_price,
              dis_id: item.dis_id,
              dis_price: item.dis_price,
              food_count: item.meal_count,
              number: item.meal_count,
              menu_id: item.menu_id,
              menu_spec_id: item.menu_spec_id,
              notice: "",
            };
            shopParams.menu.push(menu_item);
          });
          totalMealParams.order_menu.push(shopParams);
        });
        this.requestSubmitOrders(totalMealParams);
      }

      //增加咖啡订单提交到另外一个服务
    },
    /**
     * 发起下订单请求
     */
    requestSubmitOrders(totalMealParams) {
      // 提交订单
      this.APIS.SUBMIT_ORDERS(totalMealParams)
        .then((res) => {
          this.submiting = false;
          if (res.data.status === 0) {
            // 订单成功，清除购物车信息
            this.clearShoppingCart();
            this.$store.commit("show_alert", "菜品订单下单成功");
          } else {
            this.$store.commit("show_alert", res.data.message);
          }
        })
        .catch(() => {
          this.submiting = false;
          this.$store.commit("show_alert", "暂时不能下单哦");
        });
    },
    /**
     * 打开关闭确定订单遮罩
     */
    toggleShowConfirmOrder() {
      // 如果正在提交中
      if (this.submiting) {
        this.$store.commit("show_alert", "提交订单中，请勿重复提交！");
        return;
      }
      this.showConfirmOrderView = !this.showConfirmOrderView;
    },
  },
};
</script>

<style lang="less" scoped>
.list-enter-active,
.list-leave-active {
  transition: all 0.2s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.shopping-root-view {
  display: flex;
  flex-direction: row;
  position: fixed;
  height: calc(~"100% - 70px");
  right: 0;
  top: 72px;
  z-index: 999;
  .shopping-cart-container {
    width: 60px;
    height: 200px;
    cursor: pointer;
    margin-top: 30vh;
    .shopping-cart-icon {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ff9a28;
      border-radius: 8px 0px 0px 0px;
      .icon {
        width: 30px;
        height: 28px;
      }
      .meals-number {
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        margin-top: -12px;
        margin-left: 12px;
        font-size: 12px;
        color: #ffffff;
        border-radius: 10px;
        background-color: #ff4c4c;
      }
    }
    .shopping-cart-text {
      width: 100%;
      height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #31302e;
      border-radius: 0px 0px 0px 8px;
      .text {
        width: 20px;
        height: 64px;
        font-size: 20px;
        color: #ffffff;
      }
      .arrow-icon {
        width: 20px;
        height: 20px;
        margin-top: 20px;
      }
    }
  }
  .shopping-record {
    width: 300px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 70px;
    border-left: 1px solid #e0e0e0;
    background-color: #ffffff;
    margin-right: -300px;
    .record-view-coffee {
      width: 300px;
      // height: calc(~"100% - 60px");
      display: flex;
      flex-direction: column;
      align-items: center;
      // overflow-y: scroll;
      // overflow-x: hidden;
    }
    .record-view {
      width: 300px;
      height: calc(~"100% - 60px");
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow-y: scroll;
      overflow-x: hidden;
      .no-goods {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999999;
      }
    }
    .submit-view {
      width: 300px;
      display: flex;
      flex-direction: column;
      position: absolute;
      bottom: 0;
      .bl {
        width: 300px;
        height: 6px;
        background-color: #fafafa;
      }
      .totao-price {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .price-text {
          font-size: 16px;
          color: #333333;
        }
        .price {
          font-size: 16px;
          color: #ff4c4c;
          margin-right: 20px;
        }
      }
      .submit-wrapper {
        display: flex;
        flex-direction: row;
        .clear,
        .submit {
          width: 150px;
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 18px;
          color: #ffffff;
          cursor: pointer;
        }
        .clear {
          background-color: #31302e;
        }
        .submit {
          background-color: #ff9a28;
          .submiting-img {
            width: 54px;
            height: 54px;
          }
        }
      }
    }
    .goto-orders {
      position: absolute;
      bottom: 0;
      width: 300px;
      height: 60px;
      background-color: #ff9a28;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .animateIn {
    margin-right: 0;
    transition: all 0.3s ease;
  }
  .animateOut {
    margin-right: -300;
    transition: all 0.3s ease;
  }
}

//咖啡样式
.shop-view {
  width: 300px;
  height: 40px;
  display: flex;
  align-items: center;
  margin-top: 15px;
  background-color: #f5f5f5;
  .shop-icon {
    width: 16px;
    height: 16px;
    margin-left: 10px;
  }
  .shop-title {
    margin-left: 10px;
    font-size: 18px;
    color: #333333;
  }
}

.remarks-view {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  margin-top: 8px;
  cursor: pointer;
  margin-left: 16px;
  .remarks-icon {
    width: 20px;
    height: 20px;
  }
  .remarks-title {
    font-size: 16px;
    margin-left: 5px;
    color: #999999;
  }
  .remarks-text {
    margin-left: 10px;
    font-size: 16px;
    color: #333333;
    outline: none;
    border: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shopping_cart/index.vue